import { useCallback, useEffect, useRef, useState } from "react";
import { Button, Card, Col, Container, Image, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { BiLeftArrowAlt } from "react-icons/bi";
import Loader from "react-js-loader";
import Moment from 'react-moment';
import { NumericFormat } from 'react-number-format';
import { useNavigate, useParams } from 'react-router-dom';
import ReactToPrint from 'react-to-print';
import stempelIcon from '../../icons/stempel.png';
import ttdIcon from '../../icons/ttd.png';
import BrandLogo from '../../logo.png';
import { getEndpointUrl, getTimestamp } from "../../Utils/Common";
import Error404 from "../Error404";
import { FaFolderOpen } from "react-icons/fa";

const DetilInspector = () => {
    const componentRef = useRef(null);

    const [error404, setError404] = useState(false);

    const [isLoading, setLoading] = useState(true);

    const [images, setImages] = useState([]);

    const [userLogin] = useState(
        JSON.parse(localStorage.getItem('knowLogin')) || []
    );

    const [accesToken] = useState(
        JSON.parse(localStorage.getItem('credentials')) || []
    );

    const navigate = useNavigate();

    const params = useParams();

    let numberCheckPoint = 1;

    const [item, setItem] = useState([]);

    const fetchDataItem = useCallback(async (item_id) => {
        setLoading(true);
        fetch(getEndpointUrl() + `/v2/inspector/${item_id !== undefined ? item_id : 0}?v=${getTimestamp()}`, {
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`,
            }),
        }).then(response => response.json()).then(json => {
            if (json.status === 'ok') {
                setItem(json.results);
            } else {
                setError404(true);
            }

            setLoading(false);
        });
    }, []);

    const fetchImages = useCallback(async (id) => {
        fetch(getEndpointUrl() + `/v2/inspector/images/${id}?v=${getTimestamp()}`, {
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`
            })
        }).then(response => response.json()).then(json => {
            if (json.status == 'ok') {
                setImages(json.results || []);
            } else {
                setImages([]);
            }
        }).catch(() => setImages([]));
    }, [accesToken]);

    useEffect(() => {
        fetchDataItem(params.item_id);
        fetchImages(params.item_id);
    }, [params]);


    return error404 ? <Error404 /> : (
        <>
            <Container className="mt-4">
                <Row className="mb-4 d-print-none">
                    <Col lg={12}>
                        <Button variant="secondary" onClick={() => navigate(-1)} className="pe-3"><BiLeftArrowAlt /> Kembali</Button>

                        <ReactToPrint
                            trigger={() => <Button variant="outline-secondary" className="mx-2">Cetak Hasil Inspeksi</Button>}
                            content={() => componentRef.current}
                        />
                        {/* <Button variant="success">Kirim Hasil Inspeksi</Button> */}
                    </Col>
                </Row>
                {isLoading ?
                    <Row>
                        <Col className="d-flex justify-content-center mt-5 pt-5 mb-3">
                            <Loader type="bubble-scale" bgColor={"#42A5F5"} size={100} />
                        </Col>
                    </Row> :
                    <Row>
                        <Helmet>
                            <title>PDF-{`${item.brandName} - ${item.type}`}-{item.policeNumber}</title>
                        </Helmet>
                        <Col lg={12} className="mt-5" ref={componentRef}>
                            <Row>
                                <Col>
                                    <Image src={BrandLogo} alt="Brand Logo" fluid className="mb-3" />
                                </Col>
                            </Row>
                            <Row className="mt-3">
                                <Col>
                                    <strong className="text-uppercase fw-bold fs-14">INSPECTION REPORT INSPECTOR MOBIL</strong>
                                </Col>
                            </Row>
                            <div className="p-3 border mt-3 rounded-3 text-uppercase">
                                <Row className="fs-13">
                                    <Col>
                                        <span className="fw-bold">Merek</span><br />
                                        <span>{`${item.brandName}`}</span>
                                    </Col>
                                    <Col>
                                        <span className="fw-bold">Tipe</span><br />
                                        <span>{item.type}</span>
                                    </Col>
                                    <Col>
                                        <span className="fw-bold">Model</span><br />
                                        <span>{item.modelName}</span>
                                    </Col>
                                </Row>
                                <Row className="fs-13 mt-3">
                                    <Col>
                                        <span className="fw-bold">Tahun</span><br />
                                        <span>{item.builtYear}</span>
                                    </Col>
                                    <Col>
                                        <span className="fw-bold">Odometer</span><br />
                                        <NumericFormat
                                            value={item.odometer}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                            prefix={''}
                                            renderText={(value, props) => <span {...props}>{value} KM</span>} />
                                    </Col>
                                    <Col>
                                        <span className="fw-bold">Nomor Polisi</span><br />
                                        <span>{item.policeNumber}</span>
                                    </Col>
                                </Row>
                                <Row className="fs-13 mt-3">
                                    <Col>
                                        <span className="fw-bold">Transmisi</span><br />
                                        <span>{item.transmission}</span>
                                    </Col>
                                    <Col md={8} sm={8} xs={8}>
                                        <span className="fw-bold">Warna</span><br />
                                        <span>{item.color}</span>
                                    </Col>
                                </Row>
                                <Row className="fs-13 mt-3">
                                    <Col>
                                        <span className="fw-bold">Pajak</span><br />
                                        <span>{item.tax}</span>
                                    </Col>
                                    <Col>
                                        <span className="fw-bold">Buku Servis</span><br />
                                        <span>{item.serviceRecords}</span>
                                    </Col>
                                    <Col>
                                        <span className="fw-bold">Buku Manual</span><br />
                                        <span>{item.manualBook}</span>
                                    </Col>
                                </Row>
                                <Row className="fs-13 mt-3">
                                    <Col>
                                        <span className="fw-bold">Lokasi</span><br />
                                        <span>{item.location}</span>
                                    </Col>
                                    <Col>
                                        <span className="fw-bold">Tanggal Inspeksi</span><br />
                                        <span><Moment format="DD/MM/YYYY - HH:mm A">{item.inspection_date}</Moment></span>
                                    </Col>
                                    <Col>
                                        <span className="fw-bold">Petugas Inspeksi</span><br />
                                        <span>{item.inspectorName}</span>
                                    </Col>
                                </Row>
                            </div>
                            <Row>
                                <Col>
                                    <table className="table table-bordered table-striped fs-13 mt-3 table-inspeksi">
                                        <tr className="bg-secondary text-light">
                                            <th width={30} className="px-3 py-2">#</th>
                                            <th className="text-uppercase py-2">ITEM / KOMPONEN / FEATURE</th>
                                            <th className="text-uppercase py-2">KELENGKAPAN</th>
                                            <th className="text-uppercase py-2">KONDISI / FUNGSI</th>
                                        </tr>
                                        {item.inspeksi?.length > 0 && item.inspeksi.map((val, key) =>
                                            <>

                                                <tr className={`align-top bg-secondary text-uppercase`} key={`cat-${++key}`}>
                                                    <th colSpan={5} className="py-2 px-2 text-light">{val.name}</th>
                                                </tr>
                                                {val.results?.length > 0 && val.results.map((val, key) =>
                                                    <>
                                                        <tr className={`align-top ${val.availability == `NOT OK` || val.availability == `TIDAK NORMAL` ? `text-danger` : `text-dark`}`} key={`tr3-${++key}`}>
                                                            <td>{`${numberCheckPoint++}.`}</td>
                                                            <td className="text-uppercase py-2 fw-bold">{val.name}</td>
                                                            <td className="ps-0">{val.availability}</td>
                                                            <td className="ps-0">
                                                                {val.choices?.length > 0 ?
                                                                    <ul className="bg-transparent">
                                                                        {val.choices.map((condition, key) =>
                                                                            <li key={`li-${key}`} className={`${condition == `OK` ? `text-dark` : `text-danger`}`}>{condition}</li>
                                                                        )}
                                                                        {val.otherChoice &&
                                                                            <li key={`li-${key}`} className={`${val.otherChoice == `OK` ? `text-dark` : `text-danger`}`}>{val.otherChoice}</li>
                                                                        }
                                                                    </ul>
                                                                    : <ul className="bg-transparent">
                                                                        {val.otherChoice && <li className={`${val.otherChoice == `OK` ? `text-dark` : `text-danger`}`}>{val.otherChoice}</li>}
                                                                    </ul>

                                                                }
                                                                {val.note && <p> <span className="fw-medium"> Catatan :</span><br /><span className="fst-italic">{val.note}</span></p>}
                                                            </td>
                                                        </tr>
                                                    </>
                                                )}
                                            </>
                                        )}

                                    </table>
                                </Col>
                            </Row>
                            <div className="page-break" />
                            <Row className="mt-3">
                                <Col>
                                    <strong className="text-uppercase fw-bold fs-14">HASIL PEMERIKSAAN</strong>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <table className="table table-bordered fs-13 mt-3">
                                        <tr style={{ verticalAlign: 'top' }}>
                                            <th width={200} className="px-3 py-2">Hasil Scanner</th>
                                            <th width={5} className="text-center">:</th>
                                            <td className="py-2">
                                                {item.scanner !== null &&
                                                    <div className="bg-transparent" dangerouslySetInnerHTML={{ __html: item.scanner.replace(/\r?\n/g, '<br />') }}></div>
                                                }
                                            </td>
                                        </tr>
                                        <tr style={{ verticalAlign: 'top' }}>
                                            <th className="px-3 py-2">Note</th>
                                            <th width={5} className="text-center">:</th>
                                            <td className="py-2">
                                                {item.note !== null &&
                                                    <div className="bg-transparent" dangerouslySetInnerHTML={{ __html: item.note.replace(/\r?\n/g, '<br />') }}></div>
                                                }
                                            </td>
                                        </tr>
                                        <tr style={{ verticalAlign: 'top' }}>
                                            <th className="px-3 py-2">Kesimpulan</th>
                                            <th width={5} className="text-center">:</th>
                                            <td className="py-2">
                                                {item.kesimpulan !== null &&
                                                    <div className="bg-transparent" dangerouslySetInnerHTML={{ __html: item.kesimpulan.replace(/\r?\n/g, '<br />') }}></div>
                                                }
                                            </td>
                                        </tr>
                                        <tr style={{ verticalAlign: 'top' }}>
                                            <th className="px-3 py-2">Grade Mesin</th>
                                            <th width={5} className="text-center">:</th>
                                            <td className="ps-3 fw-bold">{item.gradeMesin}</td>
                                        </tr>
                                        <tr style={{ verticalAlign: 'top' }}>
                                            <th className="px-3 py-2">Grade Exterior</th>
                                            <th width={5} className="text-center">:</th>
                                            <td className="ps-3 fw-bold">{item.gradeExterior}</td>
                                        </tr>
                                        <tr style={{ verticalAlign: 'top' }}>
                                            <th className="px-3 py-2">Grade Interior</th>
                                            <th width={5} className="text-center">:</th>
                                            <td className="ps-3 fw-bold">{item.gradeInterior}</td>
                                        </tr>
                                        <tr style={{ verticalAlign: 'top' }}>
                                            <th className="px-3 py-2">Saran Perawatan</th>
                                            <th width={5} className="text-center">:</th>
                                            <td className="py-2">
                                                {item.saranPerawatan !== null &&
                                                    <div className="bg-transparent" dangerouslySetInnerHTML={{ __html: item.saranPerawatan.replace(/\r?\n/g, '<br />') }}></div>
                                                }
                                            </td>
                                        </tr>
                                    </table>
                                    <p><strong>Keterangan :</strong></p>
                                    <table className="fs-13 mt-3 table-bordered">
                                        <tr style={{ verticalAlign: 'top' }}>
                                            <th width={10} className="px-3 py-2">A</th>
                                            <th width={10} className="px-3 py-2">:</th>
                                            <td className="py-2 px-3">Istimewa</td>
                                            <th width={10} className="px-3 py-2">C</th>
                                            <th width={10} className="px-3 py-2">:</th>
                                            <td className="py-2 px-3">Cukup</td>
                                        </tr>
                                        <tr style={{ verticalAlign: 'top' }}>
                                            <th width={10} className="px-3 py-2">B</th>
                                            <th width={10} className="px-3 py-2">:</th>
                                            <td className="py-2 px-3">Sangat Baik</td>
                                            <th width={10} className="px-3 py-2">D</th>
                                            <th width={10} className="px-3 py-2">:</th>
                                            <td className="py-2 px-3">Kurang / Buruk</td>
                                        </tr>
                                        <tr style={{ verticalAlign: 'top' }}>
                                            <th width={10} className="px-3 py-2">C+</th>
                                            <th width={10} className="px-3 py-2">:</th>
                                            <td className="py-2 px-3">Baik</td>
                                            <th width={10} className="px-3 py-2">E</th>
                                            <th width={10} className="px-3 py-2">:</th>
                                            <td className="py-2 px-3">Sangat Buruk</td>
                                        </tr>
                                    </table>
                                </Col>
                            </Row>
                            <Row className="mt-5 fs-13">
                                <Col>
                                    <p className="px-5 mb-0 pb-0">Hormat Kami,</p>
                                    <div className="stempel">
                                        <Image src={stempelIcon} alt="Stempel Image" className="mx-3" width={250} />
                                    </div>
                                    <Image src={ttdIcon} alt="TTD Image" className="mx-3 ttd" width={150} />
                                    <p className="px-4">
                                        <span className="text-uppercase fw-medium text-decoration-underline">KRISMA PRIANJANI</span><br />
                                        <span>DIREKTUR</span>
                                    </p>
                                </Col>
                            </Row>
                            <div className="page-break" />
                            <Row>
                                <Col>
                                    <div className="d-flex justify-content-between my-2">
                                        <div>
                                            <h6>Foto Hasil Temuan Inspeksi</h6>
                                        </div>
                                    </div>
                                    {/* If empty foto inspection */}
                                    {images.length === 0 && (
                                        <div className='my-2'>
                                            <div className="alert alert-secondary text-center" role="alert">
                                                <div>
                                                    <FaFolderOpen className="fs-2 text-muted" />
                                                </div>
                                                <p className='mt-3 pb-0'>
                                                    Belum ada foto inspeksi apapun disini. Silahkan ungah foto inspeksi.
                                                </p>
                                            </div>
                                        </div>
                                    )}
                                    {/* End if empty foto inspection */}
                                    {/* If not empty foto inspection */}
                                    {images.length > 0 && (
                                        <div className='my-2'>
                                            <Row>
                                                {images.map((img) => (
                                                    <Col key={img.id} md={6} lg={6}>
                                                        <img
                                                            variant="top"
                                                            src={getEndpointUrl() + img.file_path}
                                                            style={{ width: '100%', objectFit: 'cover' }}
                                                        />
                                                        <p className="text-muted fst-italic text-xs">{img.caption}</p>
                                                    </Col>
                                                ))}
                                            </Row>
                                        </div>
                                    )}
                                    {/* End if not empty foto inspection */}
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                }
            </Container>
        </>
    );
}

export default DetilInspector;
